module.exports = __webpack_public_path__ + "img/Aija-Lagzdina.b6a1a660.svg";